module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_1000_2500.2a2a6a5d.png";